<template>
  <div class="login">
    <div class="wrap clearfix">
      <div class="welcome" style="position:relative;padding-top:100px">
        <div class="welcome-title" style="margin-top:20px">
          <div style="font-family:'Varela Round', sans-serif;font-size:1.165em;font-weight:700;line-height:1.5;">WELCOME</div>
          <div style="font-family:'Varela Round', sans-serif;font-size:1.165em;font-weight:700;line-height:1.5;">LET'S GET STARTED</div>
        </div>
        <img v-if="widthChange" src="../assets/img/jiantou.png" alt />
      </div>
      <div class="login-box" :class="[shakeFlag?'shake_lr':'',noAniFlag?'noani':'']">
        <div class="login-title">
          <a href="https://www.npn.sg/">
            <img src="../assets/img/logo_npn.png" alt="" style="width: 60px" />
          </a>
        </div>
        <div class="pWrap" style="padding: 5px" @keydown="enterLog">
          <p>
            <input
              v-model="account"
              type="text"
              placeholder="Account"
              @input="checkAccount"
              class="form_control"
              ref="account"
              :style="
                accountFlag
                  ? 'box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26'
                  : ''
              "
              @blur="accountBlur"
              @focus="accountFocus"
            />
          </p>
          <p>
            <input
              v-model="password"
              type="password"
              ref="password"
              placeholder="Password"
              @input="checkPassword"
              @blur="passwordBlur"
              @focus="passwordFocus"
              class="form_control"
              :style="
                passwordFlag
                  ? 'box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26'
                  : ''
              "
            />
          </p>
          <p>
            <input
              v-model="verify_code"
              type="text"
              ref="code"
              placeholder="Enter code"
              @input="checkCode"
              @blur="codeBlur"
              @focus="codeFocus"
              class="form_control"
              :style="
                codeFlag
                  ? 'box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26'
                  : ''
              "
            />
            <!-- <img
              class="code-img"
              @click="getCaptcha()"
              ref="captcha"
              :src="verify_code_src"
              alt
            /> -->
            <VerifyCodes @getIdentifyCode="str"></VerifyCodes>
          </p>
          <button
            @click="LoginBtn"
            class="login-btn"
            style="margin: 0px 0px 20px 0px"
            type="button"
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisible"
      width="16%"
      :before-close="handleClose"
      center
      :show-close="false"
      class="tipsBox"
    >
      <div style="margin-bottom:5px">
        <img
          style="width: 40px; object-fit: cover; margin-bottom: 10px"
          src="../assets/img/icons/error.png"
          alt=""
        />
      </div>
      <span style="text-align: center;font-family:Montserrat-Light">{{ tips }}</span>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
        <el-button type="primary" @click="dialogVisible = false" style="width:90px">OK</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="18%"
      center
      title=""
      destroy-on-close
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
      class="wrapDialogBox"
      :show-close="false"
    >
      <el-form :model="form">
        <el-form-item
          label="Phone Number"
          :label-width="formLabelWidth"
          v-if="isSingel"
        >
          <el-input
            v-model="form.username"
            autocomplete="off"
            :disabled="true"
          ></el-input>
          <div
            style="
              position: absolute;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              padding: 0 10px;
              width: 60px;
              max-width: 60px;
            "
          >
            <!-- <div>{{ countDown }}</div> -->
            <!-- <div @click="sendOTP" v-if="!countDown">Send</div>
            <div class="countDown" v-if="countDown">{{ count }}s</div> -->
          </div>
        </el-form-item>
        <el-form-item
          :label-width="formLabelWidth"
          label="Phone Number"
          v-if="!isSingel"
        >
          <el-select
            v-model="SelectPhoneNumber"
            @change="getPhoneNumber"
            placeholder="Please select"
          >
            <el-option
              v-for="item in options"
              :key="item.contactId"
              :label="item.mobile"
              :value="item.contactId"
            >
            </el-option>
          </el-select>
          <!-- <div
            class="sendBox"
            ref="sendBox"
            :style="bigFlag=='125'?'margin-top:-1px':''"
          >
            <div @click="sendOTP" v-if="!countDown" style="font-family:Montserrat-Light !important;cursor:pointer">Send</div>
            <div class="countDown" v-if="countDown" style="font-family:Montserrat-Light !important">{{ count }}s</div>
          </div> -->
        </el-form-item>
        <el-form-item label="OTP" :label-width="formLabelWidth">
          <el-input v-model="form.otp" autocomplete="off" placeholder="Enter Otp"></el-input>
          <div
            class="sendBox"
            ref="sendBox"
          >
            <div @click="sendOTP" v-if="!countDown" style="font-family:Montserrat-Light !important;cursor:pointer;line-height:38px;">Send</div>
            <div class="countDown" v-if="countDown" style="font-family:Montserrat-Light !important">{{ count }}s</div>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false;form.otp='';SelectPhoneNumber=''">Cancel</el-button>
        <el-button type="primary" @click="submit" class="SubmitBtn">Submit</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import { authLogin,sendOtp,doLogin,checkLogin } from "@/api/account";
  import makeSign from "@/getSign";
  import local from "@/utils/local";
  import md5 from "@/md5"
  import Verify_Code from "../components/verify_code/index.vue";
  export default {
    data() {
      return {
        account: "",
        accountFlag:false,
        passwordFlag:false,
        codeFlag:false,
        password: "",
        verify_code: "",
        verify_code_src: process.env.VUE_APP_TITLE + "/verify_code?10",
        // heightChange: true,
        widthChange: true,
        docmHeight: document.documentElement.clientHeight, //默认屏幕高度
        showHeight: document.documentElement.clientHeight, //实时屏幕高度
        showWidth: document.documentElement.clientWidth,
        identifyCode:"",
        enterAccountTimes:0,
        enterPasswordTimes:0,
        enterCodeTimes:0,
        dialogVisible:false,
        dialogFormVisible2:false,
        tips:"Incorrect verification code",
        formLabelWidth: '120px',
        countDown: false,
        count:0,
        form:{
          username:"",
          otp:"",
        },
        uuid:"",
        contactId:"",
        isSingel:true,
        options:[],
        SelectPhoneNumber:"",
        ratio:"",
        bigFlag:"",
        value4:"",
        shakeFlag:false,
        noAniFlag:false,
      };
    },
    components: {
      "VerifyCodes":Verify_Code,
    },
    methods: {
      LoginBtn(){
        this.checkAccount()
        if(!this.account){
          this.$refs.account.focus()
          if(this.account){
            this.$refs.account.style=""
          }else{
            // this.$refs.account.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
          }
          this.$message({
            message: "Account cannot be empty",
            type: "warning",
          });
          this.passwordBlur()
          this.codeBlur()

        }else{
          if(!this.password){
            this.$refs.password.focus()
            if(this.password){
              this.$refs.password.style=""
            }else{
              // this.$refs.password.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
            }
            // this.passwordBlur()
            this.codeBlur()
            this.$message({
              message: "Password cannot be empty",
              type: "warning",
            });
          }else{
            if(!this.verify_code){
              this.$refs.code.focus()
              if(this.verify_code){
                this.$refs.code.style=""
              }else{
                // this.$refs.code.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
              }
              this.$message({
                message: "Verify Code cannot be empty",
                type: "warning",
              });
            }else{
              
              console.log(this.verify_code,this.identifyCode)
              if(this.verify_code.toLowerCase() === this.identifyCode.toLowerCase()){
                console.log("请求");
                console.log(md5.hex_md5(this.password))
                let newPwd = md5.hex_md5(this.password)
                let result = {
                  username: this.account,
                  password: newPwd,
                };
                const sign = this.$makeSign.makeSign(result);
                console.log(sign);
                localStorage.setItem("sign", sign);
                authLogin(result).then((res)=>{
                  console.log(res);
                  if(res.code == 200){
                    this.dialogFormVisible2 = true
                    this.uuid = res.data.uuid
                    if (this.ratio == 125) {
                      this.bigFlag = "125"
                    } else if (this.ratio == 150) {
                      this.bigFlag = "150"
                    } else if (this.ratio == 100) {
                      this.bigFlag = "100"
                    }
                    if(res.data.contactInfo.length==1){
                      this.form.username = res.data.contactInfo[0].mobile
                      this.contactId = res.data.contactInfo[0].contactId
                    }else if(res.data.contactInfo.length > 1){
                      this.isSingel = false
                      this.options = res.data.contactInfo
                    }
                    
                  }else if(res.msg == 'Account or password is wrong!'){
                    this.shakeFlag = true;
                    this.noAniFlag = false;
                    setTimeout(() => {
                      this.dialogVisible = true;
                      this.tips = res.msg
                      this.shakeFlag = false;
                      this.noAniFlag = true;
                    }, 1001);
                  }else{
                    console.log("1234");
                    this.dialogVisible = true
                    this.tips = res.msg
                  }
                })
                
              }else{
                console.log("验证码错误");
                this.shakeFlag = true;
                this.noAniFlag = false;
                setTimeout(() => {
                  this.dialogVisible = true;
                  this.tips = "Verification Code Invalid!"
                  this.verify_code = ""
                  this.$bus.$emit("reloadFlag",true)
                  this.shakeFlag = false;
                  this.noAniFlag = true;
                }, 1001);
                
              }
            }
            
          }
        }
        // if(!this.account || !this.password || !this.verify_code){
        //   this.$message({
        //     message: "Content cannot be empty",
        //     type: "warning",
        //   });
        // }
      },
      sendOTP(){
        console.log(this.SelectPhoneNumber)
        if(this.SelectPhoneNumber){
          console.log(this.contactId,this.uuid)
          const result = {
            uuid:this.uuid,
            contactId:this.SelectPhoneNumber,
          }
          const sign = this.$makeSign.makeSign(result)
          localStorage.setItem("sign",sign)
          console.log(result)
          sendOtp(result).then((res)=>{
            console.log(res)
            if(res.code == 200){
              this.countDown = true;
              this.timer();
            }else{
              this.dialogVisible = true;
              this.tips = res.msg
            }
          })
        }else if(this.form.username){
          console.log(this.contactId,this.uuid)
          const result = {
            uuid:this.uuid,
            contactId:this.contactId,
          }
          const sign = this.$makeSign.makeSign(result)
          localStorage.setItem("sign",sign)
          console.log(result)
          sendOtp(result).then((res)=>{
            console.log(res)
            if(res.code == 200){
              this.countDown = true;
              this.timer();
            }else{
              this.dialogVisible = true;
              this.tips = res.msg
            }
          })
        }else{
          this.dialogVisible = true;
          this.tips = "Please select the number"
        }
        // sendOtp()
      },
      timer() {
        this.count = 60;
        // var timer = setInterval(this.count--, 1000);
        var time = setInterval(() => {
          this.count--;
          // console.log(this.count);
          if (this.count < 0) {
            clearInterval(time);
            this.countDown = false;
          }
        }, 1000);
      },
      getPhoneNumber(){
        console.log(this.SelectPhoneNumber)
      },
      handleClose(){
        this.dialogVisible = false
      },
      str(e) {
        this.identifyCode = e;
      },
      checkAccount(){
        if(this.account){
          this.accountFlag = false
          this.$refs.account.style=""
        }else{
          // this.accountFlag = true
          // this.$refs.account.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
        }
      },
      accountBlur(){
        if(this.account){
          this.$refs.account.style=""
        }else{
          this.$refs.account.style="border-color:rgba(241, 91, 38, 0.5)"
        }
      },
      accountFocus(){
        // this.$refs.account.style="border:1px solid"
        if(this.enterAccountTimes>0){
          if(this.account){
            this.$refs.account.style=""
          }else{
            // this.$refs.account.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
          }
        }else{
          this.$refs.account.style=""
        }
        this.enterAccountTimes ++
      },
      passwordFocus(){
        if(this.enterPasswordTimes>0){
          if(this.password){
            this.$refs.password.style=""
          }else{
            // this.$refs.password.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
          }
        }else{
          this.$refs.password.style=""
        }
        this.enterPasswordTimes ++
      },
      codeFocus(){
        if(this.enterCodeTimes>0){
          if(this.verify_code){
            this.$refs.code.style=""
          }else{
            // this.$refs.code.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
          }
        }else{
          this.$refs.code.style=""
        }
        this.enterCodeTimes ++
      },
      checkPassword(){
        if(this.password != ""){
          this.passwordFlag = false
          this.$refs.password.style=""
        }else{
          // this.passwordFlag = true
          // this.$refs.password.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
        }
        console.log(this.passwordFlag);
      },
      passwordBlur(){
        if(this.password){
          this.$refs.password.style=""
        }else{
          this.$refs.password.style="border-color:rgba(241, 91, 38, 0.5)"
        }
      },
      checkCode(){
        if(this.verify_code){
          this.codeFlag = false
          this.$refs.code.style=""
        }else{
          // this.codeFlag = true
          // this.$refs.code.style="box-shadow:inset 0 1px 1px rgb(0 0 0 / 8%) ,0 0 6px #ce8483;border-color:#f15b26"
        }
      },
      codeBlur(){
        if(this.verify_code){
          this.$refs.code.style=""
        }else{
          this.$refs.code.style="border-color:rgba(241, 91, 38, 0.5)"
        }
      },
      // 获取一个新的图形验证码
      getCaptcha(event) {
        var num = Math.ceil(Math.random() * 10);
        this.$refs.captcha.src = process.env.VUE_APP_TITLE + "/verify_code?" + num;
      },
      enterLog(e){
        if(e.keyCode == 13){
          this.LoginBtn()
        }
      },
      submit(){
        console.log(this.uuid,this.form.otp)
        if(this.SelectPhoneNumber || this.form.username){
          if(this.form.otp){
            let result = {
              uuid:this.uuid,
              otp:this.form.otp
            }
            const sign = this.$makeSign.makeSign(result)
            localStorage.setItem("sign",sign)
            doLogin(result).then((res)=>{
              console.log(res)
              if(res.code == 200){
                location.href = res.data.redirectUrl
                localStorage.setItem("token",res.data.token)
              }else{
                this.dialogVisible = true;
                this.tips = res.msg
              }
            })
          }else{
            this.dialogVisible = true;
            this.tips = "Please enter the Otp"
          }
        }else{
          this.dialogVisible = true;
          this.tips = "Please enter the phone number"
        }
        
        
      },
      resizeFunc() {
        let ratio = 0;
        let screen = window.screen;
        let ua = navigator.userAgent.toLowerCase();

        if (window.devicePixelRatio !== undefined) {
          ratio = window.devicePixelRatio;
        }
        else if (~ua.indexOf('msie')) {
          if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI;
          }
        }
        else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
          ratio = window.outerWidth / window.innerWidth;
        }

        if (ratio) {
          ratio = Math.round(ratio * 100);
        }
        this.ratio = ratio

        
      }
      // Md5Pws() {},
    },
    mounted() {
      // // window.onresize监听页面高度的变化
      window.onresize = () =>
        (() => {
          this.showHeight = document.body.clientHeight;
          this.showWidth = document.body.clientWidth;
        })();
    },
    created () {
      this.resizeFunc();
      console.log(this.ratio)
      let tk = localStorage.getItem("token")
      if(tk){
        const result = {
          token:tk
        }
        const sign = this.$makeSign.makeSign(result)
        localStorage.setItem("sign",sign)
        checkLogin(result).then((res)=>{
          console.log(res)
          if(res.code == 200){
            
            location.href = res.data.redirectUrl
          }else if(res.code == 403){
            localStorage.removeItem("token")
          }
        })
      }
      
    },
    // watch: {
    //   showHeight() {
    //     if (this.docmHeight > this.showHeight) {
    //       this.heightChange = false;
    //     } else {
    //       this.heightChange = true;
    //     }
    //   },
    // },
  };
</script>

<style lang="less" scoped>
@font-face {
  font-family: "title";
  src: url("../assets/font/CENSCBK.TTF");
}
@font-face {
  font-family: "Varela Round";
  src: url("../assets/font/Varela Round.woff2.ttf");
}
@font-face {
  font-family: "Montserrat-Light";
  src: url("../assets/font/Montserrat-Light.otf");
}
@keyframes lefteaseinAnimate {
  0% {
    transform: translateX(-2000px);
    opacity: 0;
  } /*在0%时设置文字在想X轴-2000px位移处（左边），透明度为0，也就是看不见文字*/
  100% {
    transform: translateX(0px);
    opacity: 1;
  } /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
}
@-webkit-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-o-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-ms-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-moz-keyframes lefteaseinAnimate {
  0% {
    -webkit-transform: translateX(-2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
/*定义一个名字为righteaseinAnimate动画，实现从页面的右边淡入页面效果*/
@keyframes righteaseinAnimate {
  0% {
    transform: translateX(2000px);
    opacity: 0;
  } /*在0%时设置文字在想X轴2000px位移处（右边），透明度为0，也就是看不见文字*/
  100% {
    transform: translateX(0px);
    opacity: 1;
  } /*在100%时设置文字在想X轴0px位移处，也就是原始布局的位置，透明度为1，也就是文字可以看见了*/
}
@-webkit-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-o-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-ms-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}
@-moz-keyframes righteaseinAnimate {
  0% {
    -webkit-transform: translateX(2000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0px);
    opacity: 1;
  }
}

.shake_lr {
    animation: shake_lr 1000ms ease-in-out !important;
}
@keyframes shake_lr {
    10%, 90% { transform: translate3d(-2px, 0, 0); }
    20%, 80% { transform: translate3d(+4px, 0, 0); }
    30%, 70% { transform: translate3d(-8px, 0, 0); }
    40%, 60% { transform: translate3d(+8px, 0, 0); }
    50% { transform: translate3d(-8px, 0, 0); }
}

@media screen and (min-width: 992px) {
  .login-box.noani{
    animation: none !important;
  }
  .login {
    height: 100%;
    position: relative;
    background: url(../assets/img/login_bg.jpg);
    display: flex;
    justify-content: center;
    align-items: center;
    background-repeat: no-repeat;
    background-size: cover;
    /deep/ .el-input__inner{
        border: 1px solid #d3d3d3 !important;
      }
    .wrap {
      width: 1000px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      // align-items: center;
    }
    .wrap.clearfix::after {
      display: table;
      content: "";
      clear: both;
    }
    .welcome {
      // position: absolute;
      // top: 50%;
      // left: 50%;
      // transform: translate(-80%, -50%);
      float: left;
      // display: flex;
      flex: 1;
      animation: lefteaseinAnimate 2s ease 1; //调用已定义好的动画lefteaseinAnimate，全程运行时间2s，进入的速度曲线为ease，只播放一次
      -webkit-animation: lefteaseinAnimate 2s ease 1;
      -ms-animation: lefteaseinAnimate 2s ease 1;
      -o-animation: lefteaseinAnimate 2s ease 1;
      -moz-animation: lefteaseinAnimate 2s ease 1;
      /*规定动画的最后状态为结束状态*/
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      -ms-animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      .welcome-title {
        font-size: 30px;
        color: #ffffff;

        & > P {
          margin-bottom: 0px;
        }
      }

      & > img {
        // margin-top: 100px;
        // margin-left: 100px;
        position:absolute;
        right:100px;
      }
    }
    .tipsBox{
      font-family: "Montserrat-Light";
      /deep/ .el-dialog.el-dialog--center{
        border-radius: 6px !important;
        min-width: 300px;
      }
    }
    
    .sendBox{
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      // border: 1px solid #dcdfe6;
      border-left: 1px solid #dcdfe6;
      width: 60px;
      height: 39px;
      max-width: 60px;
      // border-top-right-radius:4px;
      // border-bottom-right-radius:4px;
      margin-top:0px;
    }
    .wrapDialogBox{
      /deep/ .el-dialog.el-dialog--center{
        min-width: 340px;
      }
    }
    .login-box {
      width: 350px;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 30px;
      font-size: 14px;
      // position: absolute;
      padding: 15px;
      float: right;
      box-sizing: border-box;
      // top: 50%;
      // transform: translateY(-50%);
      // right: 15%;
      animation: righteaseinAnimate 2s ease 1;
      -webkit-animation: righteaseinAnimate 2s ease 1;
      -moz-animation: righteaseinAnimate 2s ease 1;
      -ms-animation: righteaseinAnimate 2s ease 1;
      -o-animation: righteaseinAnimate 2s ease 1;
      /*规定动画的最后状态为结束状态*/
      animation-fill-mode: forwards;
      -webkit-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      -ms-animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      .login-title {
        text-align: center;
        margin: 30px 0;

        & > h1 {
          font-size: 25px;
          color: #ff9800;
          font-style: italic;
          font-family: "title";
        }

        & > hr {
          margin-top: 11px;
          width: 30px;
          background: #ff9800;
          height: 2px;
          border: none;
        }
      }

      .pWrap > p {
        width: 100%;
        display: flex;

        & > input {
          width: 100%;
          background: rgba(255, 255, 255, 0.4);
          border: solid 1px #d3d3d3;
          outline: none;
          height: 40px;
          margin-bottom: 20px;
          border-radius: 5px;
          text-indent: 10px;
          font-size: 14px !important;
          font-family:"Montserrat-Light" !important
        }
        & > input:focus {
          border: 1px solid #f90;
          // box-shadow:#f90 0px 0px 6px,0px 1px 1px #fff inset;
          box-shadow:0px 2px 8px 0px rgba(173,173,173,0.5);
          border-color:#f90;
        }

        .code-img {
          margin-left: 10px;
          width: 100px;
          height: 44px;
        }
      }

      .login-btn {
        width: 100%;
        height: 40px;
        background-color: #ff9900;
        border-radius: 5px;
        color: #fff;
        font-family: "Montserrat-Light";
        outline: none;
        border: none;
        cursor: pointer;
      }
      .login-btn:hover{
        box-shadow: 0px 8px 25px -8px #f88f00;
      }
    }
    .form_control {
      transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
    }
    /deep/ .el-dialog {
      margin-top: 34vh !important;
    }
    /deep/ .el-dialog__body {
      text-align: center;
      padding: 15px 24px 15px;
    }
    /deep/ .el-form-item {
      text-align: left;
    }
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item {
      margin-bottom: 0px;
    }
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
      position: relative;
      .el-select {
        // width: calc(100% - 60px);
        width:100%;
        // .el-input__inner {
        //   border-top-right-radius: 0px;
        //   border-bottom-right-radius: 0px;
        // }
      }
    }
    /deep/ .el-button.el-button--default{
      width: 80px;
      padding: 12px 0px;
      text-align: center;
      min-width: 60px;
      border-color:#d3d3d3;
      span{
        font-family: "Montserrat-Light";
      }
    }
    /deep/ .el-button.el-button--default:hover{
      border-color:#eeeeee;
      background-color:#f9f9f9;
      color:#606266;
    }
    /deep/ .el-input__inner{
      font-family: "Montserrat-Light" !important;
    }
    /deep/ .el-form-item__label{
      font-family: "Montserrat-Light" !important;
    }
    /deep/ .el-dialog__header{
      padding: 10px;
    }
    /deep/ .el-button.el-button--primary {
      width: 80px;
      padding: 12px 0px;
      text-align: center;
      min-width: 60px;
      background-color: #1cce72;
      border-color: #1cce72;
      cursor: pointer;
      span{
        font-family: "Montserrat-Light";
      }
    }
    /deep/ .el-button.el-button--primary:hover{
      box-shadow: 0px 8px 25px -8px #1cce72;
    }
    /deep/.el-dialog__close.el-icon.el-icon-close:hover::before{
      color: #f88f00;
    }
    /deep/ .el-input__inner:focus{
      border-color: #f88f00;
    }
    /deep/ .el-input.el-input--suffix.is-focus input.el-input__inner{
      border-color: #f88f00;
    }
    
    .wrapDialogBox{
      /deep/ .el-dialog__header{
        padding: 0;
      }
      /deep/ .el-dialog.el-dialog--center{
        border-radius: 5px !important;
      }
    }
    /deep/ .SubmitBtn{
      background-color: #f88f00 !important;
      border-color: #f88f00 !important;
    }
    /deep/ .SubmitBtn:hover{
      box-shadow: 0px 8px 25px -8px #f88f00 !important;
    }
    
  }
  
}

@media screen and (max-width: 992px) {
  .login {
    width: 100%;
    height: 100%;
    background: url(../assets/img/login_bg.jpg);
    // background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    background-repeat: no-repeat;
    background-size: cover;
    /deep/ .el-input__inner{
        border: 1px solid #d3d3d3 !important;
      }
    .wrap{
      width: 100%;
    }
    .welcome {
      position: absolute;
      left: 30px;
      top: 30px;
      display: none;
      .welcome-title {
        font-size: 26px;
        color: #ffffff;

        & > P {
          margin-bottom: 5px;
        }
      }

      & > img {
        display: none;
      }
    }

    .login-box {
      // width: 280px;
      width: 86%;
      margin: 0 auto;
      background-color: rgba(255, 255, 255, 1);
      border-radius: 30px;
      padding: 20px 20px 30px 20px;
      box-sizing: border-box;
      
      .pWrap>p{
        margin-bottom: 15px;
        display: flex;
        input{
          height: 34px;
          width:100%;
          text-indent: 10px;
          border-width: 1px;
          border-radius: 4px;
          border: 1px solid #d3d3d3;
        }
        input:focus {
          border: 1px solid #f90;
          // box-shadow:#f90 0px 0px 6px,0px 1px 1px #fff inset;
          box-shadow:0px 2px 8px 0px rgba(173,173,173,0.5);
          border-color:#f90;
        }
      }
      /deep/ .s-canvas{
        max-width: 80px;
        canvas#s-canvas{
          width: 100% !important;
          height: 100% !important;
          margin-left: 0px;
        }
      }
      .login-title {
        text-align: center;
        margin: 30px 0;

        & > h1 {
          font-size: 20px;
          color: #ff9800;
          font-style: italic;
          font-family: "title";
        }

        & > hr {
          margin-top: 11px;
          width: 30px;
          background: #ff9800;
          height: 2px;
          border: none;
        }
      }

      & > p {
        width: 100%;
        display: flex;

        & > input {
          width: 100%;
          background: rgba(255, 255, 255, 0.4);
          border: solid 1px #c9c9c9;
          outline: none;
          height: 35px;
          margin-bottom: 25px;
          text-indent: 10px;
          
        }

        .code-img {
          margin-left: 10px;
          width: 100px;
          height: 39px;
        }
      }

      .login-btn {
        width: 100%;
        height: 42px;
        background-color: #f90;
        border-radius: 10px;
        color: #fff;
        outline: none;
        border: none;
        margin-bottom: 10px !important; 
        margin-top: 10px !important;
      }
    }
    .sendBox{
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      // border: 1px solid #dcdfe6;
      border-left: 1px solid #dcdfe6;
      width: 60px;
      height: 39px;
      max-width: 60px;
      // border-top-right-radius:4px;
      // border-bottom-right-radius:4px;
      margin-top:0px;
    }
    .tipsBox{
      font-family: "Montserrat-Light";
      /deep/ .el-dialog.el-dialog--center{
        border-radius: 6px !important;
        min-width: 280px;
      }
    }
    /deep/ .el-dialog {
      margin-top: 34vh !important;
    }
    /deep/ .el-dialog__body {
      text-align: center;
      padding: 15px 10px 15px;
      span{
        word-break: break-word;
      }
    }
    /deep/ .el-form-item {
      text-align: left;
    }
    /deep/ .el-form-item__label {
      float: none;
    }
    /deep/ .el-form-item {
      margin-bottom: 0px;
    }
    /deep/ .el-form-item__content {
      margin-left: 0px !important;
      position: relative;
      .el-select {
        // width: calc(100% - 60px);
        width:100%;
        // .el-input__inner {
        //   border-top-right-radius: 0px;
        //   border-bottom-right-radius: 0px;
        // }
      }
    }
    /deep/ .el-button.el-button--default{
      width: 80px;
      padding: 12px 0px;
      text-align: center;
      min-width: 60px;
      border-color: #d3d3d3 !important;
      span{
        font-family: "Montserrat-Light";
      }
    }
    /deep/ .el-button.el-button--default:hover{
      border-color:#eeeeee;
      background-color:#f9f9f9;
      color:#606266;
    }
    /deep/ .el-input__inner{
      font-family: "Montserrat-Light" !important;
    }
    /deep/ .el-form-item__label{
      font-family: "Montserrat-Light" !important;
    }
    /deep/ .el-dialog__header{
      padding: 10px;
    }
    /deep/ .el-button.el-button--primary {
      width: 80px;
      padding: 12px 0px;
      text-align: center;
      min-width: 60px;
      background-color: #1cce72;
      border-color: #1cce72;
      cursor: pointer;
      span{
        font-family: "Montserrat-Light";
      }
    }
    /deep/ .el-button.el-button--primary:hover{
      box-shadow: 0px 8px 25px -8px #1cce72;
    }
    /deep/.el-dialog__close.el-icon.el-icon-close:hover::before{
      color: #f88f00;
    }
    /deep/ .el-input__inner:focus{
      border-color: #f88f00;
    }
    /deep/ .el-input.el-input--suffix.is-focus input.el-input__inner{
      border-color: #f88f00;
    }
    .wrapDialogBox{
      /deep/ .el-dialog__header{
        padding: 0;
      }
      /deep/ .el-dialog.el-dialog--center{
        border-radius: 5px !important;
      }
    }
    /deep/ .SubmitBtn{
      background-color: #f88f00 !important;
      border-color: #f88f00 !important;
    }
    /deep/ .SubmitBtn:hover{
      box-shadow: 0px 8px 25px -8px #f88f00 !important;
    }
    .wrapDialogBox{
      /deep/ .el-dialog.el-dialog--center{
        min-width: 320px;
        
      }
      /deep/ .el-dialog__body{
          padding: 15px 20px;
        }
    }
  }
}
</style>